import { defineMessages, IntlShape } from "react-intl";

enum UserLocationSettingVisibility {
  OWNER = "owner",
  OWNER_MANAGER = "owner-manager",
  PUBLIC = "public",
  NONE = "none",
}

export const messages = defineMessages<UserLocationSettingVisibility>({
  [UserLocationSettingVisibility.NONE]: {
    id: "userLocationSettingVisibility.none",
    defaultMessage: "Nobody",
    description: "User location setting visibility = nobody",
  },
  [UserLocationSettingVisibility.OWNER]: {
    id: "userLocationSettingVisibility.owner",
    defaultMessage: "Organization owners only",
    description: "User location setting visibility = owner",
  },
  [UserLocationSettingVisibility.OWNER_MANAGER]: {
    id: "userLocationSettingVisibility.ownerManager",
    defaultMessage: "Team managers and organization owners",
    description: "User location setting visibility = owner and managers",
  },
  [UserLocationSettingVisibility.PUBLIC]: {
    id: "userLocationSettingVisibility.public",
    defaultMessage: "All users (will only see themselves)",
    description: "User location setting visibility = public",
  },
});

export const getUserLocationSettingVisibilityDisplayName = (
  intl: IntlShape,
  visibility: UserLocationSettingVisibility
) => intl.formatMessage(messages[visibility]);

export default UserLocationSettingVisibility;
